import { require200Status } from "../../utils/response.js";
import { persistDueAt } from "../../../hooks/useDateAvailCheck.js";
import { FieldType } from "../../../types/api.js";
import { transformWithSpec } from "../../../utils/response.js";
const OTPTransformResponse = (response, meta, params) => {
  const transformFn = transformWithSpec({
    nextRequestAt: FieldType.DateTime,
    expiredAt: FieldType.DateTime
  });
  const transformedRes = transformFn(response);
  try {
    persistDueAt(params.phone, transformedRes.nextRequestAt);
  } catch (e) {
    console.error("Failed to persist due at", e);
  }
  return transformedRes;
};
function registerEndpoints(builder) {
  return {
    createRegister: builder.mutation({
      invalidatesTags: ["register"],
      query: (body) => ({
        url: "/register/create",
        method: "POST",
        body,
        validateStatus: require200Status
      }),
      transformResponse: OTPTransformResponse
    }),
    submitRegister: builder.mutation({
      invalidatesTags: ["register"],
      query: (body) => ({
        url: "/register/submit",
        method: "POST",
        body,
        validateStatus: require200Status
      }),
      transformResponse: transformWithSpec()
    }),
    verifyOTP: builder.mutation({
      invalidatesTags: ["register"],
      query: (req) => ({
        url: "/register/verify",
        method: "POST",
        body: req,
        validateStatus: require200Status
      }),
      transformResponse: transformWithSpec()
    }),
    createForgotPassword: builder.mutation({
      query: (body) => ({
        url: "/register/forgot-password",
        method: "POST",
        body,
        validateStatus: require200Status
      }),
      transformResponse: OTPTransformResponse
    }),
    submitResetPassword: builder.mutation({
      query: (body) => ({
        url: "/register/reset-password",
        method: "POST",
        body
      }),
      transformResponse: transformWithSpec()
    })
  };
}
export {
  registerEndpoints as default
};
